export const CARD_MESSAGES = {
  SUCCESS: 'card_connect.success',
  ERROR: 'card_connect.error',
} as const;
